import * as React from 'react';
import classnames from 'classnames';

import Tooltip from 'components/Tooltip';

import { expandDataProps } from 'utils/helper/common';

import './input-radio.scss';

import type {
  Data,
  ElementDirection
} from 'types';

type Props = {
  id: string,
  label: string | React.ReactNode,
  value: string,
  name?: string,
  size?: 'normal' | 'large',
  labelClassName?: string,
  tooltipMessage?: string,
  disabled?: boolean,
  required?: boolean,
  checked: boolean,
  checkedLabelEmphasis?: boolean,
  data?: Data,
  tootlipAfter?: true,
  tooltipDirection?: ElementDirection,
  refCallback?: (ref: any) => void,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
  onKeyPress?: (event: React.SyntheticEvent<HTMLInputElement>) => void,
  onBlur?: (event: React.SyntheticEvent<HTMLInputElement>) => void,
  onMouseEnter?: (event: React.SyntheticEvent<HTMLLabelElement>, value: string) => void,
  onMouseLeave?: (event: React.SyntheticEvent<HTMLLabelElement>, value: string) => void
};

class InputRadio extends React.Component<Props> {
  static defaultProps = {
    size: 'normal',
    disabled: false,
    required: false,
    checkedLabelEmphasis: false,
    onKeyPress: () => {},
    onBlur: () => {}
  };

  handleMouseEnter = (event: React.SyntheticEvent<HTMLLabelElement>): void => {
    const { onMouseEnter, value } = this.props;

    if (onMouseEnter) {
      onMouseEnter(event, value);
    }
  };

  handleMouseLeave = (event: React.SyntheticEvent<HTMLLabelElement>): void => {
    const { onMouseLeave, value } = this.props;

    if (onMouseLeave) {
      onMouseLeave(event, value);
    }
  };

  render(): React.ReactNode {
    const {
      refCallback,
      id,
      label,
      labelClassName,
      size,
      data,
      disabled,
      tooltipMessage,
      checkedLabelEmphasis,
      tootlipAfter,
      tooltipDirection,
      // those are suppressed since they also not belong to inputProps, so should be skipped
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onMouseEnter,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onMouseLeave,
      ...inputProps
    } = this.props;

    const containerClasses = classnames({
      'input-radio': true,
      'input-radio--disabled': disabled
    });

    const labelClasses = classnames({
      'input-radio__label': true,
      'input-radio__label--disabled': disabled,
      'input-radio__label--emphasize': inputProps.checked && checkedLabelEmphasis,
      [`input-radio__label--size-${String(size)}`]: size,
      [String(labelClassName)]: Boolean(labelClassName)
    });

    const tooltipMarkup = (
      <span className="input-radio__tooltip-mark">
        <Tooltip
          tooltipDirection={tooltipDirection}
          message={tooltipMessage}
          showQuestionMark
        />
      </span>
    );

    return (
      <section className={containerClasses}>
        <input
          id={`radio-${id}`}
          type="radio"
          className="input-radio__input"
          ref={refCallback}
          disabled={disabled}
          {...expandDataProps(data)}
          {...inputProps}
        />
        <label // eslint-disable-line jsx-a11y/label-has-for
          className={labelClasses}
          htmlFor={`radio-${id}`}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          {!tootlipAfter && tooltipMessage && tooltipMarkup}
          <span>{label}</span>
          {tootlipAfter && tooltipMessage && tooltipMarkup}
        </label>
      </section>
    );
  }
}

export default InputRadio;
